import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { SuperButton } from "@swiggy-private/dls-web-core/dist/components/SuperButton";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled from "styled-components";

export const HalfCardWrapper = styled.div(({ theme }) => ({
    padding: theme.spacing.medium,
    paddingBottom: `calc(var(--sab, 0px) + ${theme.spacing.medium})`,
}));

export const HalfCardContentWrapper = styled.div(({ theme }) => ({
    padding: theme.spacing.xSmall,
}));

export const StyledTitleText = styled(Text)(({ theme }) => ({
    marginTop: theme.spacing.xSmall,
    maxWidth: "240px",
}));

export const ContentWrapper = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "flex-end",
    gap: theme.spacing.xSmall,
}));

export const ContentContainer = styled.div(({ theme }) => ({
    marginTop: theme.spacing.large,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.large,
}));

export const StyledButton = styled(SuperButton)(({ theme }) => ({
    marginTop: theme.spacing.large,
    marginBottom: theme.spacing.medium,
}));

export const StyledStepperImage = styled(Image)(({ theme }) => ({
    width: "13px",
    height: "125px",
    position: "relative",
    bottom: theme.spacing.xxxSmall,
}));
